"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = __importDefault(require("./Handler"));
var utils_1 = require("../utils");
var EZImager = (function (_super) {
    __extends(EZImager, _super);
    function EZImager(src, props) {
        var _this = _super.call(this, src, props) || this;
        _this.name = "ezbuy";
        _this.originSrc = _this.imageUrl;
        return _this;
    }
    EZImager.prototype.getCompatibleImageUrl = function () {
        return this.compatibleImageUrl;
    };
    EZImager.prototype.makeImageUrls = function () {
        var sourceWithWebpAndSize, sourceWithJpgAndSize, sourceWithWebp, sourceWithJpg;
        var src = this.getCompatibleImageUrl();
        if (src.endsWith("/webp")) {
            sourceWithWebpAndSize = src;
            sourceWithWebp = src.replace(/(\?imageView2\/\d\/)(?:.+)$/, function (match, p1) { return p1 + "format/webp"; });
        }
        sourceWithJpgAndSize = src.replace(/(\/format\/)webp$/, function (match, p1) { return p1 + "jpg"; });
        sourceWithJpg = src.replace(/(\?imageView2\/\d\/)(?:.+)$/, function (match, p1) { return p1 + "format/jpg"; });
        return utils_1.dropEmptyValue([
            sourceWithWebpAndSize,
            sourceWithWebp,
            sourceWithJpgAndSize,
            sourceWithJpg,
            this.originSrc === sourceWithJpg ? "" : this.originSrc
        ]);
    };
    EZImager.match = function (src) {
        return true;
    };
    return EZImager;
}(Handler_1.default));
exports.default = EZImager;
